var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-btn-icon",
    {
      attrs: {
        color: _vm.color,
        icon: _vm.generateMessagePath("icon"),
        outlined: _vm.isOutlined,
        text: _vm.hasLabel ? _vm.generateMessagePath(`title`) : "",
        "tooltip-text": _vm.hasTooltip ? _vm.generateMessagePath(`title`) : ""
      },
      on: {
        click: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.handleClick.apply(null, arguments)
        }
      }
    },
    [
      _vm.isBtnText || _vm.hasLabel
        ? _c("div", [_vm._v(_vm._s(_vm.generateMessagePath(`title`)))])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }